<template>
  <div class="map">
    <div class="inner">
      <div class="list" v-if="mapList.length > 0">
        <div
          class="item"
          v-for="(item, index) in mapList"
          :key="index"
          @click="review(index)"
        >
          <img :src="item.cover" alt="" />
          <div class="cover">
            <div class="title">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <Pagination
        :total="total"
        :pageSize="6"
        @repeater="repeater"
        v-if="mapList.length > 0"
      />
      <Nodata v-else />
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
    >
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in mapList"
            :key="index"
          >
            <img :src="item.cover" alt="" />
          </div>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Swiper from "swiper/swiper-bundle.min.js";
import "swiper/swiper-bundle.min.css";
import { getBannerList } from "@/api/banner";
export default {
  data() {
    return {
      dialogVisible: false,
      page: 1,
      total: 0,
      mapList: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    init(index) {
      new Swiper(".swiper-container", {
        loop: true, // 循环模式选项
        autoplay: false,
        initialSlide: index,
        observer: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    async getData() {
      const res = await getBannerList({
        page: this.page,
        banner_type: 3,
        limit: 6,
      });
      this.mapList = res.data.results;
      console.log(res.data.paging.total);
      this.total = res.data.paging.total;
    },
    repeater(val) {
      this.page = val;
      this.getData();
    },
    review(index) {
      this.dialogVisible = true;
      setTimeout(() => {
        this.init(index);
      }, 500);
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.map {
  box-sizing: border-box;
  .inner {
    width: 1200px;
    margin: 0 auto;
    @media only screen and (max-width: 900px) {
      width: 90%;
    }
    .list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: flex-start;
      .item {
        width: 348px;
        height: 260px;
        margin-right: 18px;
        margin-bottom: 18px;
        cursor: pointer;
        position: relative;
        @media only screen and (max-width: 900px) {
          width: 348px;
          height: 260px;
          margin-bottom: 18px;
          margin-right: 0;
        }
        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
        .cover {
          position: absolute;
          visibility: hidden;
          height: 60px;
          transition: all 0.5s linear;
          background-color: rgba($color: #09090a, $alpha: 0.73);
          left: 0;
          bottom: 0;
          width: 100%;
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
          text-align: left;
          padding: 20px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          @media only screen and (max-width: 900px) {
            visibility: visible;
            font-size: 14px;
            height: 30px;
          }
          .subTitle {
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            @media only screen and (max-width: 900px) {
              font-size: 14px;
            }
          }
        }
        &:hover .cover {
          visibility: visible;
        }
      }
    }
  }
}
::v-deep .swiper-container {
  width: 100%;
  height: 80vh;
  @media only screen and (max-width: 900px) {
    height: 40vh;
  }
}
::v-deep .el-dialog {
  box-shadow: none;
  background-color: transparent;
}
::v-deep .swiper-button-prev {
  left: 136px;
  z-index: 10;
  background-image: url("~@/assets/img/home/btn_arrow_02.png");
  background-size: contain;
  background-repeat: no-repeat;
  width: 68px;
  height: 130px;
  &::after {
    content: "";
  }
}
::v-deep .swiper-button-next {
  right: 136px;
  z-index: 666 !important;
  width: 68px;
  height: 130px;
  background-image: url("~@/assets/img/home/btn_arrow_01.png");
  background-size: contain;
  background-repeat: no-repeat;
  &::after {
    content: "";
  }
}
::v-deep .swiper-slide {
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
